import { render, staticRenderFns } from "./TheStudentMenu.vue?vue&type=template&id=f6aa200e&scoped=true"
import script from "./TheStudentMenu.vue?vue&type=script&lang=js"
export * from "./TheStudentMenu.vue?vue&type=script&lang=js"
import style0 from "./TheStudentMenu.vue?vue&type=style&index=0&id=f6aa200e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6aa200e",
  null
  
)

export default component.exports